import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBlogContext } from "../../fetchdata/BlogContext";
import axios from "axios";
import CreateSlug from "./extra/CreateSlug";

const Footer = () => {
    const navigate = useNavigate();
  
   const { Headers, isHeader, cartItems, AllProducts, AllCategoriess,LocationHeaders ,IsUserData} =
     useBlogContext();
  const filteredLocations = LocationHeaders;
 

   
  return (
    <>

        {IsUserData?.myorder && IsUserData.myorder.length > 0 && (
      <div className="fix-otp border-top shadow border p-0" >
        <div className="bg-opacity-50 bg-success p-2">

      
          <b> Active Orders </b> 
          <div className="mt-2">
    { IsUserData.myorder.map((order) => ( 
             order.OTP &&  <div key={order._id} className="otp-box mb-2 d-inline-block me-2 border p-2 bg-white small"> <p className="m-0"> Order Id : {order.orderId}  <span className="bg-success text-white py-1 px-2 ms-3"> OTP: {order.OTP}</span> </p> </div>  
             ))
         }
           </div>
             </div>
         </div>
          )
        }
    


  {/* Most Popular Cities */}
  <div className="bg-maroon border-top border-bottom cities-footer gold-border">
    <div>
      <div className="container">
        <a
          className="w-100 text-gold text-decoration-none py-3 d-block"
          data-bs-toggle="collapse"
          href="#collapseExample"
          role="button"
          aria-expanded="false"
          aria-controls="collapseExample"
        >
          <div className="d-flex flex-wrap justify-content-between align-items-center py-1">
            <h6 className="m-0 text-body fw-bold">Most Popular Cities</h6>
            <span>
              See all Cities{" "}
              <i className="fa fa-angle-down border p-1 ms-2 rounded-3" />{" "}
            </span>
          </div>
        </a>
      </div>
    </div>
    <div className="collapse border-top" id="collapseExample">
      <div className="container py-4">
        <div className="row">
 
             
                                  {filteredLocations.length > 0 ? (
                      filteredLocations.map((item) => {
                        const stateSlug = CreateSlug(item);
            
                        return (
                               <div key={item} className="col-6 col-lg-2 col-md-3">
            <Link  type="button"  
              className="py-2 text-decoration-none d-block w-100 text-muted"
              to={`/${stateSlug}`}
            >
               {item}
            </Link>
            
          </div> 

           );
                      })
                    ) : (
                      <li className="p-3">No matching results</li>
                    )}
            
                           
     
        
        </div>
      </div>
    </div>
  </div>
  {/* Footer */}
  <div className="py-5 footer bg-dark">
    <div>
      <div className="container py-4">
        <div className="row">


          {isHeader
  ? // Display loading skeletons while data is being fetched
    Array.from({ length: 1 }).map((_, index) => (
      <div className="col-6 col-lg-4 col-md-3 pe-lg-5" key={index}>
        <div className="footer-widget">
          <div
            className="skeleton mb-4"
            style={{ height: 24, width: 100, borderRadius: 5 }}
          ></div>
          <ul className="footer-menu">
            {Array.from({ length: 3 }).map((__, i) => (
              <li key={i}>
                <div
                  className="skeleton mt-1"
                  style={{ height: 20, width: 80, borderRadius: 5 }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))
  : Headers.footer !== undefined &&
    Headers.footer.slice(0, 1).map((item, index) => (
         <div className="col-6 col-lg-4 col-md-3 pe-lg-5" key={index} >
            {/* <a href="index.html" class="d-flex align-items-center mb-4 text-decoration-none">
               <img src="img/site/logo.png" class="img-fluid cw-60" alt="Helply" />
               </a> */}
            <h5 className="mb-3 text-white fw-bold">
              <b className="text-primary">{item.text}</b>
            </h5>
             {item.children.map((childItem, childIndex) => (
              <p key={childIndex} className="text-white-50" >
              {childItem.text}  {childItem.link && <Link to={childItem.link} > ReadMore </Link> }
            </p>
          
            ))}
            
            </div>
 
    ))}
 
          {isHeader
  ? // Display loading skeletons while data is being fetched
    Array.from({ length: 1 }).map((_, index) => (
      <div className="col-6 col-lg-2 col-md-3" key={index}>
        <div className="footer-widget">
          <div
            className="skeleton mb-4"
            style={{ height: 24, width: 100, borderRadius: 5 }}
          ></div>
          <ul className="footer-menu">
            {Array.from({ length: 3 }).map((__, i) => (
              <li key={i}>
                <div
                  className="skeleton mt-1"
                  style={{ height: 20, width: 80, borderRadius: 5 }}
                ></div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    ))
  : Headers.footer !== undefined &&
    Headers.footer.slice(1, 4).map((item, index) => (
         <div className="col-6 col-lg-2 col-md-3"  key={index} >
            <h6 className="mb-3 text-white fw-bold"> {item.text} </h6>
              {item.children.map((childItem, childIndex) => (
                 <Link key={childIndex}
              className="py-2 text-decoration-none d-block w-100 text-white-50"
             to={childItem.link}
            >
           <i className="fa fa-angle-right text-white me-2" />   {childItem.text}
            </Link>
            ))} 
          </div>
 
    ))}


  
        
          <div className="col-6 col-lg-2 col-md-3">
            <h6 className="mb-3 text-white fw-bold text-uppercase">
              Contact Us
            </h6>
        

             {!isHeader && (
              <>
                  <div className="d-flex gap-3 py-2">
              <i className="ri-map-pin-2-fill text-primary" />{" "}
              <span className="text-white-50"> <i className="fa fa-location-arrow text-white me-2"/> {Headers.address} </span>
            </div>
               <div className="d-flex gap-3 py-2">
              <i className="ri-mail-open-fill text-primary" />{" "}
              <a href={`mailto:${Headers.email}`} className="text-white-50"> <i className="fa fa-envelope text-white me-2"/> {Headers.email}</a>
            </div> 
            
            <div className="d-flex gap-3 py-2">
              <i className="ri-phone-fill text-primary" />{" "}
              <a href={`tel:${Headers.phone}`} className="text-white-50"> <i className="fa fa-phone text-white me-2"/>
 +91 {Headers.phone}</a>
            </div>

              </>
              
                    )}

           
          </div>


        </div>
      </div>
    </div>
  </div>
  <div className="py-4 bg-maroon footer-copyright border-top gold-border">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-8">
          <span className="me-3 text-gold">
             {!isHeader && Headers.footer_credit}{" "}| Design by{" "}
                  <a href="https://seotowebdesign.com/" target="blank" className="text-gold fw-bold">
                    Seo To Webdesign{" "}
                  </a>
                  <br />
                  <small className="text-gold opacity-75">THE ART OF EXCELLENCE</small>
          </span>
          
        </div>
        <div className="col-md-4 text-end">
          <a target="_blank" href="#" className="h5 mb-0 mx-2 text-gold">
            <i className="ri-facebook-circle-line" />
          </a>
          <a target="_blank" href="#" className="h5 mb-0 mx-2 text-gold">
            <i className="ri-twitter-line" />
          </a>
          <a target="_blank" href="#" className="h5 mb-0 mx-2 text-gold">
            <i className="ri-linkedin-box-line" />
          </a>
          <a target="_blank" href="#" className="h5 mb-0 mx-2 text-gold">
            <i className="ri-youtube-line" />
          </a>
          <a target="_blank" href="#" className="h5 mb-0 mx-2 text-gold">
            <i className="ri-instagram-line" />
          </a>
        </div>
      </div>
    </div>
  </div>
  
    

    </>
  );
};

export default Footer;
